import React, { useReducer, useContext } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { api } from '../../../services/api'
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import toast from 'react-hot-toast'
import { Box, Tooltip, TextField, Select, InputLabel, FormControl, MenuItem, Autocomplete } from '@mui/material'
import validateData from './validateData';
import { externalComponent } from '../../AppRoutes';
import { capitalize } from '../../Utils/functions'
import { NumericFormatInput } from '../../Utils/MaskedInput';
import IntegerOnly from '../../Utils/IntegerOnly';
import CircularProgress from '@mui/material/CircularProgress';
import timeoutList from '../../Utils/TimeoutList';

const url = '/service/'

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const submit = async (data, getData, setLoader, handleClose) => {

    setLoader(true)
    let res = null

    if (data.id)
        res = await api.patch(`${url}${data.id}/`, { ...data, documents: data.documents })
    else
        res = await api.post(url, data)
    if (res.status === 201 || res.status === 200) {
        toast.success(`Serviço ${res.status === 201 ? 'adicionado' : 'editado'} com sucesso`)
        getData()
        handleClose()
        setLoader(false)
        return
    }
    toast.error(`Serviço não pôde ser ${!data.id ? 'adicionado' : 'editado.'} Motivo: ${res.data}`)
    setLoader(false)
}

const EditServiceModal = ({ data, handleClose, reloadData, documents, items = {} }) => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        name: '',
        ...data,
        id: data.id ? data.id : 0,
        value: data.value ? String(data.value) : '',
        periodicity: data.periodicity || 0,
        periodicity_unit: data.periodicity_unit || 'MONTHS',
    })

    const [helpers, setHelpers] = useReducer(lockedReducer, {
        loaded_plagues: []
    })

    const validData = validateData(state)

    return (
        <>
            <DefaultModal
                title={
                    `${getTitle(state)} Serviço`
                }
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' >
                            <Box sx={{ display: 'flex', gap: 1 }}>

                                <TextField
                                    sx={{ flex: 2 }}
                                    id="name"
                                    type="text"
                                    label="Nome"
                                    value={state.name}
                                    onChange={(e) => { setState({ 'name': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />

                                <TextField
                                    sx={{ flex: 1 }}
                                    id="valor"
                                    type="text"
                                    label="Valor"
                                    value={state.value}
                                    onChange={(e) => { setState({ 'value': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    InputProps={{
                                        inputComponent: NumericFormatInput
                                    }}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, paddingTop: 1 }}>
                                <Tooltip title='Tempo até o serviço precisar ser refeito. Deixe 0 para serviços sem retorno.'>
                                    <TextField
                                        sx={{ flex: 2 }}
                                        id="periodicity"
                                        type="text"
                                        label="Periodicidade do Serviço"
                                        value={state.periodicity}
                                        onChange={(e) => { setState({ 'periodicity': IntegerOnly(e.target.value, 0, 9999) }) }}
                                        fullWidth={false}
                                        size='small'
                                    />
                                </Tooltip>
                                <FormControl sx={{ flex: 1 }} size='small'>
                                    <InputLabel id="select-periodicity-unit-label">Unidade</InputLabel>
                                    <Select
                                        labelId="select-periodicity-unit-label"
                                        id="select-periodicity-unit"
                                        label="Unidade"
                                        value={state.periodicity_unit}
                                        onChange={(e) => { setState({ 'periodicity_unit': e.target.value }) }}
                                    >
                                        <MenuItem value='DAYS'>Dias</MenuItem>
                                        <MenuItem value='MONTHS'>Meses</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box>
                    </>
                }
                action={
                    <>
                        <Tooltip placement="left" title={validData}>
                            <Box>
                                <ColorButton
                                    onClick={() => submit(state, reloadData, setLoader, handleClose)}
                                    disabled={validData}
                                >Salvar
                                </ColorButton>
                            </Box>
                        </Tooltip>
                    </>
                }
            />
        </>
    )
}

export default EditServiceModal